import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../app-routing.module';
import { LogedComponent } from './loged/loged.component';
import { PublicComponent } from './public/public.component';
import { ComponentesComponent } from './componentes/componentes.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [LogedComponent, PublicComponent, ComponentesComponent],
  imports: [AppRoutingModule, CommonModule, ComponentsModule],
})
export class ContainersModule {}
